import {
  LoanExtensionStateTypes,
  LoanExtensionActionTypes,
} from "./LoanExtension.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: LoanExtensionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const LoanExtensionReducer = (
  state: LoanExtensionStateTypes = INITIAL_STATE,
  action: any
): LoanExtensionStateTypes => {
  switch (action.type) {
    case LoanExtensionActionTypes.FETCH_ALL_LOAN_EXTENSION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case LoanExtensionActionTypes.FETCH_ALL_LOAN_EXTENSION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LoanExtensionActionTypes.FETCH_ALL_LOAN_EXTENSION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LoanExtensionActionTypes.FETCH_ALL_LOAN_EXTENSION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case LoanExtensionActionTypes.FETCH_ONE_LOAN_EXTENSION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case LoanExtensionActionTypes.FETCH_ONE_LOAN_EXTENSION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case LoanExtensionActionTypes.FETCH_ONE_LOAN_EXTENSION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case LoanExtensionActionTypes.FETCH_ONE_LOAN_EXTENSION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default LoanExtensionReducer;
